import { Box, styled } from '@mui/material'

export const AppBody = styled(Box, { name: 'AppBody' })({
  display: 'block',
  flex: '0 1 auto',
  height: '100%',
  overflow: 'hidden',
})
